import { render, staticRenderFns } from "./GetDiploma.vue?vue&type=template&id=43ec9f20&scoped=true"
import script from "./GetDiploma.vue?vue&type=script&lang=js"
export * from "./GetDiploma.vue?vue&type=script&lang=js"
import style0 from "./GetDiploma.vue?vue&type=style&index=0&id=43ec9f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ec9f20",
  null
  
)

export default component.exports